<div class="breadcrumb-container" id="breadcrumbContainer">
  <ds-breadcrumbs id="leadsBreadcrumbs" [breadcrumbs]="breadcrumbs" separatorType="slash" [collapsable]="false" [iconStyle]="isMobile ? 'material-icons-outlined' : null"></ds-breadcrumbs>
</div>

@if (!isMobile) {
  <div class="header-container" [ngClass]="{'small': !displayedModule}">
    <div class="header-title">
      <typography id="quoteTitle" variant="mat-headline-6" weight="bold"> {{ title }}</typography>
    </div>
    <div class="header-buttons">
      @if (editLeadComponent?.canEdit && editLeadComponent?.isOnline) {
        @if ((editLeadComponent?.isDeliveryEditMode || editLeadComponent?.isLeadEditMode) && !editLeadComponent?.disableEditDelivery) {
          <ds-button
            id="leadDeleteButton" class="quarter-width" size="large" type="secondary" variant="label-only"
            (onClick)="confirmDeleteLead($event)" [label]="appStrings.button_delete">
          </ds-button>
        }
      }
      @if (editLeadComponent?.disableEditDelivery) {
        <ds-button class="quarter-width" size="large"
          type="secondary" variant="label-only" id="closeBtn" (onClick)="confirmClose()"
          [label]="appStrings.button_close">
        </ds-button>
      }
      @if (!editLeadComponent?.disableEditDelivery && displayedModule !== 0) {
        <ds-button id="cancelButton"
          class="quarter-width" size="large" type="secondary" variant="label-only" (onClick)="confirmCancel()"
          [label]="appStrings.button_cancel">
        </ds-button>
      }
      @if (displayedModule === 0) {
        <ds-button class="quarter-width" size="large" type="secondary"
          variant="label-only" id="closeBtn" (onClick)="close()" [label]="appStrings.button_back">
        </ds-button>
      }
      @if (editLeadComponent?.isOnline && !editLeadComponent?.disableEditDelivery && displayedModule !== 0) {
        @if (editLeadComponent?.isDeliveryEditMode) {
          <div>
            @if (editLeadComponent?.canEdit) {
              <ds-button id="saveButtonEdit" class="quarter-width" size="large" type="primary"
                variant="label-only" (onClick)="editDeliverySaveChanges()" [label]="appStrings.button_save">
              </ds-button>
            }
          </div>
        } @else {
          <ds-button id="saveButtonNew" class="quarter-width" size="large" type="primary"
            variant="label-only" (onClick)="saveChanges()" [label]="appStrings.button_save">
          </ds-button>
        }
      }
    </div>
  </div>
}

@switch (displayedModule) {
  @case (1) {
    <app-edit-lead [action]="displayedAction" [leadIdInput]="itemId"></app-edit-lead>
  }
  @case (3) {
    <app-edit-lead [action]="displayedAction" [deliveryIdInput]="itemId"></app-edit-lead>
  }
  @case (4) {
    <app-edit-lead [action]="displayedAction" [leadIdInput]="itemId"></app-edit-lead>
  }
  @case ('2') {
    pie2
  }
  @default {
    <!-- Desktop view -->
    <div *appIsDesktop>
      <div class="lead-section-container">
        <ds-paper class="card" id="newDeliveryLocation" outline="outlined" elevation="elevation_none">
          <div class="header">
            <ds-icon id="newDeliveryLocationIcon" class="round-icon no-pointer-cursor" icon="local_shipping" iconStyle="material-icons-outlined"></ds-icon>
            <typography id="newDeliveryLocationTitle" variant="mat-headline-6" weight="bold" class="title">{{appStrings.lead_newDeliveryMessage}}</typography>
          </div>
          <div class="divider">
            <ds-divider></ds-divider>
          </div>
          <typography id="newDeliveryLocationBody" class="body" variant="mat-body-1">{{appStrings.lead_newDeliveryLocation_Message}}</typography>
          <div class="button-container">
            <ds-button id="accounts-leads-add-new-delivery-location" (click)="navigateToNewDeliveryLocation()"
              variant="label-only" type="primary" [label]="appStrings.button_add" size="medium">
            </ds-button>
          </div>
        </ds-paper>
        <ds-paper class="card" id="newLead" outline="outlined" elevation="elevation_none">
          <div class="header">
            <ds-icon id="newLeadIcon" class="round-icon no-pointer-cursor" icon="how_to_reg" iconStyle="material-icons-outlined"></ds-icon>
            <typography id="newLeadTitle" variant="mat-headline-6" weight="bold" class="title">{{appStrings.button_newLead}}</typography>
          </div>
          <div class="divider">
            <ds-divider></ds-divider>
          </div>
          <typography id="newLeadBody" class="body" variant="mat-body-1">{{appStrings.lead_newLeadHeaderMessage}}</typography>
          <div class="button-container">
            <ds-button id="accounts-leads-add-lead" (click)="navigateToNewLead()"
              variant="label-only" type="primary" [label]="appStrings.button_add" size="medium">
            </ds-button>
          </div>
        </ds-paper>
      </div>
    </div>
    <!-- Mobile view -->
    <div *appIsMobile class="mobile">
      <div class="mobile-content">
        <div id="mobileTitle" class="title">
          <typography variant="mat-headline-4" weight="bold"> {{ appStrings.lead_selectType }}</typography>
        </div>
        <ds-paper class="mobile-card" id="newLeadMobile" outline="outlined" elevation="elevation_none">
          <div class="card-header">
            <ds-icon id="newLeadIconMobile" class="round-icon no-pointer-cursor" icon="how_to_reg" iconStyle="material-icons-outlined"></ds-icon>
            <typography id="newLeadTitleMobile" variant="mat-headline-6" weight="bold" class="card-title">{{appStrings.button_newLead}}</typography>
            <ds-button id="accounts-leads-add-lead-mobile" (onClick)="navigateToNewLead()"
              variant="label-only" type="primary" [label]="appStrings.button_add" size="medium">
            </ds-button>
          </div>
          <div class="card-divider">
            <ds-divider></ds-divider>
          </div>
          <typography id="newLeadBodyMobile" variant="mat-body-1" class="card-description">{{appStrings.lead_newLeadHeaderMessage}}</typography>
        </ds-paper>
        <ds-paper class="mobile-card" id="newDeliveryLocationMobile" outline="outlined" elevation="elevation_none">
          <div class="card-header">
            <ds-icon id="newDeliveryLocationIconMobile" class="round-icon no-pointer-cursor" icon="local_shipping" iconStyle="material-icons-outlined"></ds-icon>
            <typography id="newDeliveryLocationTitleMobile" variant="mat-headline-6" weight="bold" class="card-title">{{appStrings.lead_newDeliveryMessage}}</typography>
            <ds-button id="accounts-leads-add-new-delivery-location-mobile" (onClick)="navigateToNewDeliveryLocation()"
              variant="label-only" type="primary" [label]="appStrings.button_add" size="medium">
            </ds-button>
          </div>
          <div class="card-divider">
            <ds-divider></ds-divider>
          </div>
          <typography id="newDeliveryLocationBodyMobile" variant="mat-body-1" class="card-description">{{appStrings.lead_newDeliveryLocation_Message}}</typography>
        </ds-paper>
      </div>
      <div class="mobile-footer">
        <ds-button id="cancelButtonMobile" variant="label-only" type="secondary" [label]="appStrings.button_cancel"
          size="medium" (onClick)="close()">
        </ds-button>
      </div>
    </div>
  }
}

<!-- Mobile sticky footer for edit/new pages -->
<ng-container *appIsMobile>
  <div class="mobile-sticky-footer" [class.hidden]="!displayedModule || displayedModule === 0">
    @if (editLeadComponent?.canEdit && editLeadComponent?.isOnline) {
      @if ((editLeadComponent?.isDeliveryEditMode || editLeadComponent?.isLeadEditMode) && !editLeadComponent?.disableEditDelivery) {
        <ds-button
          id="leadDeleteButtonMobile" size="medium" type="tertiary" variant="label-only"
          (onClick)="confirmDeleteLead($event)" [label]="appStrings.button_delete">
        </ds-button>
      }
    }

    @if (editLeadComponent?.disableEditDelivery) {
      <ds-button size="medium"
        type="secondary" variant="label-only" id="closeBtnMobile" (onClick)="confirmClose()"
        [label]="appStrings.button_close">
      </ds-button>
    }

    @if (!editLeadComponent?.disableEditDelivery) {
      <ds-button id="cancelButtonMobileFooter"
        size="medium" type="secondary" variant="label-only" (onClick)="confirmCancel()"
        [label]="appStrings.button_cancel">
      </ds-button>
    }

    @if (editLeadComponent?.isOnline && !editLeadComponent?.disableEditDelivery) {
      @if (editLeadComponent?.isDeliveryEditMode) {
        <div>
          @if (editLeadComponent?.canEdit) {
            <ds-button id="saveButtonEditMobile" size="medium" type="primary"
              variant="label-only" (onClick)="editDeliverySaveChanges()" [label]="appStrings.button_save">
            </ds-button>
          }
        </div>
      } @else {
        <ds-button id="saveButtonNewMobile" size="medium" type="primary"
          variant="label-only" (onClick)="saveChanges()" [label]="appStrings.button_save">
        </ds-button>
      }
    }
  </div>
</ng-container>